import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

interface CommentHeaderProps {
  commentCount: number;
  user: any | null;
  signInWithGoogle: () => Promise<void>;
  signOut: () => Promise<void>;
  textColor: string;
  navigate: (path: string) => void;
}

const CommentHeader: React.FC<CommentHeaderProps> = ({
  commentCount,
  user,
  signInWithGoogle,
  signOut,
  textColor,
  navigate
}) => {
  const { resolvedTheme } = useTheme();
  const borderColor = resolvedTheme === 'dark' ? 'border-white/10' : 'border-gray-200';

  return (
    <div className="mb-6">
      {user ? (
        <h3 className={cn("text-xl mb-4", textColor)}>
          {commentCount === 0 ? 'No comments yet' : `${commentCount} comment${commentCount === 1 ? '' : 's'}`}
        </h3>
      ) : (
        <div className={`mb-4 p-4 border rounded-lg backdrop-blur-sm bg-white ${borderColor}`}>
          <div className="text-center">
            <h3 className="text-xl mb-4 text-black">
              {commentCount === 0 ? 'No comments yet' : `${commentCount} comment${commentCount === 1 ? '' : 's'}`}
            </h3>
            <p className="text-gray-600">
              Please{' '}
              <button 
                onClick={() => navigate('/profile')} 
                className="text-black underline font-medium"
              >
                Login
              </button>
              {' '}or{' '}
              <button 
                onClick={() => navigate('/profile')} 
                className="text-black underline font-medium"
              >
                create an account
              </button>
              {' '}to leave a comment.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
export default CommentHeader;